// removed by extract-text-webpack-plugin
module.exports = {"colorSwatch":"_1z2ynGjD9rXvA-j6aK-QzE","colorSwatch--unavailable":"_qF0A1_lFva1hJxYKB1C4","colorSwatch__sample":"_2po-J16dfgeNFXONsxlCN_","colorSwatch__label":"_5XI2EJVa57a3BIRSg1gh5"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/ColorSwatch/InlineColorSwatchStyle.scss
// module id = 873
// module chunks = 0